"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = exports.isNodeJs = void 0;
function isNodeJs() {
    return typeof process === 'object' &&
        typeof process.versions === 'object' &&
        !!process.versions.node;
}
exports.isNodeJs = isNodeJs;
function isBrowser() {
    return !isNodeJs() && !!global['document'];
}
exports.isBrowser = isBrowser;
//# sourceMappingURL=is-nodejs.js.map